import styles from './SectionHeader.module.scss';

interface Props {
  title: string;
  dataQa?: string;
  titleComponent?: 'div' | 'h1';
}

export const SectionHeader = ({ title, dataQa, titleComponent = 'div' }: Props) => {
  const TitleComponent = titleComponent;

  return (
    <div className={styles.header} data-qa={`${dataQa}_header`}>
      <TitleComponent className={styles.title} data-qa={`${dataQa}_title`}>
        {title}
      </TitleComponent>
    </div>
  );
};
